import React from 'react';
import HomeScreen from '../../features/home';
import SearchFeaturePageShell from '../../components/shell/SearchFeaturePageShell';
import HomeSidebar from './HomeSidebar';
import CloudHomeScreen from '../../features/home/CloudHomeScreen';
import { useShellAppContext } from '../../features/shell/context/useShellAppContext';

export default function HomeScreenContainer() {
  const { productProfile } = useShellAppContext();
  const isCloud = productProfile?.id === 'cloud';
  if (isCloud) return <CloudHomeScreen />;

  return (
    <SearchFeaturePageShell
      pageId="home"
      sidebar={<HomeSidebar />}
    >
      <HomeScreen />
    </SearchFeaturePageShell>
  );
}
